import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
/**
 * fetch all Referrals entries
 */

export const fetchReferralsItems = createAsyncThunk(
  "referrals/fetchItems",
  async (vendorId, thunkAPI) => {
    const params = new URLSearchParams();
    params.append("vendor_id", vendorId);
    params.append("approval_status", "approved");
    const res = await fetch(`${API_BASE}/api/referrals?${params.toString()}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);
export const fetchReferralByID = createAsyncThunk(
  "referrals/fetchById",
  async (ReferralId, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/referrals/getByParam?_id=${ReferralId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }

    return json;
  }
);

export const updateReferral = createAsyncThunk(
  "referrals/updateReferral",
  async (
    {
      _id,
      referral_status,
      notes,
      referral_lost_reason,
      updated_at,
      expected_close_date,
      referral_member_status,
    },
    thunkAPI
  ) => {
    const res = await fetch(`${API_BASE}/api/referrals/?_id=${_id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
      body: JSON.stringify({
        referral_status,
        notes,
        referral_lost_reason,
        updated_at,
        expected_close_date,
        referral_member_status,
      }),
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();

    if (!res.ok) {
      throw new Error(json?.message || "Update failed");
    }

    return json;
  }
);
